var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelief(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 80,
    fill: "#faa51e",
    r: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m448 96c-.27 0-.537.012-.805.021a40.007 40.007 0 1 0 -78.395-16.021h-24.8a32 32 0 0 0 0 64h104a24 24 0 0 0 0-48z",
    fill: "#aac3d7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m408 224h-96a64 64 0 0 0 -128 0h-96a160 160 0 0 1 320 0z",
    fill: "#f05555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m376 224h-64a64 64 0 0 0 -128 0h-64a128 128 0 0 1 256 0z",
    fill: "#faa51e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m344 224h-32a64 64 0 0 0 -128 0h-32a96 96 0 0 1 192 0z",
    fill: "#91be41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m104 224v224h256a64 64 0 0 0 64-64v-144a16 16 0 0 0 -16-16z",
    fill: "#fab991"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m104 448h160v48h-160z",
    fill: "#fab991"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m72 240v144a32 32 0 0 0 32 32h80a32 32 0 0 0 32-32v-160h-128a16 16 0 0 0 -16 16z",
    fill: "#3c3c3c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m216 224v80a48 48 0 0 0 48-48v-32z",
    fill: "#3c3c3c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m216 253.333a48 48 0 1 0 0 96z",
    fill: "#f0915a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m152 448h112a0 0 0 0 1 0 0v48a0 0 0 0 1 0 0h-160a0 0 0 0 1 0 0 48 48 0 0 1 48-48z",
    fill: "#f0915a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m392 276a20.023 20.023 0 0 1 -20-20 4 4 0 0 1 8 0 12 12 0 0 0 24 0 4 4 0 0 1 8 0 20.023 20.023 0 0 1 -20 20z",
    fill: "#3c3c3c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m312 276a20.023 20.023 0 0 1 -20-20 4 4 0 0 1 8 0 12 12 0 0 0 24 0 4 4 0 0 1 8 0 20.023 20.023 0 0 1 -20 20z",
    fill: "#3c3c3c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m352 272a48 48 0 0 1 48 48v8a24 24 0 0 1 -24 24 24 24 0 0 1 -24-24v-56a0 0 0 0 1 0 0z",
    fill: "#f0915a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m312 368h85.333a0 0 0 0 1 0 0 32 32 0 0 1 -32 32h-21.333a32 32 0 0 1 -32-32 0 0 0 0 1 0 0z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m176 144c-.27 0-.537.012-.805.021a40.007 40.007 0 1 0 -78.395-16.021h-24.8a32 32 0 0 0 0 64h104a24 24 0 0 0 0-48z",
    fill: "#d7e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#faa51e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m328 40a8 8 0 0 1 -8-8v-8a8 8 0 0 1 16 0v8a8 8 0 0 1 -8 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.941 54.059a8 8 0 0 1 -5.657-13.659l5.656-5.657a8 8 0 0 1 11.315 11.312l-5.655 5.66a7.973 7.973 0 0 1 -5.659 2.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.059 54.059a7.975 7.975 0 0 1 -5.658-2.344l-5.656-5.657a8 8 0 0 1 11.315-11.312l5.656 5.657a8 8 0 0 1 -5.657 13.656z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelief);
export default __webpack_public_path__ + "static/media/relief.a479ac1be72567a15e68f963c683e169.svg";
export { ForwardRef as ReactComponent };